module.exports = __webpack_public_path__ + "img/courier-maritimeontario.0eeff54b.svg";